import { memo, useCallback } from 'react';

import { type AirActionTrackingLocation } from '@air/analytics';
import { type BoardCustomFieldValue } from '@air/api/types';

import { CustomFieldPlainTextTableCellInput } from '~/components/TableView/TableRow/CustomFieldTableCell/CustomFieldPlainTextTableCellInput';
import { useUpdatePublicItemsCustomFieldValue } from '~/utils/CustomFields/useUpdatePublicItemsCustomFieldValue';

export type PublicBoardCustomFieldPlainTextInputTableCellProps = {
  field: BoardCustomFieldValue;
  trackingLocation: AirActionTrackingLocation;
  boardId: string;
  closeEditor: () => void;
};

export const PublicBoardCustomFieldPlainTextInputTableCell = memo(
  ({ field, trackingLocation, boardId, closeEditor }: PublicBoardCustomFieldPlainTextInputTableCellProps) => {
    const { updatePublicItemsCustomFieldValue } = useUpdatePublicItemsCustomFieldValue();

    const updateCustomFieldValue = useCallback(
      async (value: string) => {
        await updatePublicItemsCustomFieldValue({
          boardIds: [boardId],
          baseCustomField: field,
          nextPlainTextValue: value,
          trackingLocation,
        });
      },
      [boardId, updatePublicItemsCustomFieldValue, field, trackingLocation],
    );

    return (
      <CustomFieldPlainTextTableCellInput
        onBlur={closeEditor}
        defaultValue={field.plainTextValue}
        onSubmit={updateCustomFieldValue}
        fieldName={field.name}
      />
    );
  },
);

PublicBoardCustomFieldPlainTextInputTableCell.displayName = 'PublicBoardCustomFieldPlainTextInputTableCell';
